import styles from './PrivateGamesSection.module.css'
import PopupNRI from "@/widgets/formSection/components/popupNRI.jsx";
import React, {useState} from "react";
export default function PrivateGamesSection() {

    const [isPopupOpen, setPopupOpen] = useState(false);

    return (
        <section className={`container-custom p-0`}>
            <div className={`section-title`}>Закрытая игра</div>
            <h2 className={styles.privateGame__text}>
                ХОЧЕШЬ СЫГРАТЬ В НРИ В ПРИВАТНОЙ АТМОСФЕРЕ, ТОЛЬКО С ДРУЗЬЯМИ ИЛИ КОЛЛЕГАМИ?
                МЫ ОРГАНИЗУЕМ ЗАКРЫТУЮ СЕССИЮ СПЕЦИАЛЬНО ПОД ВАШУ КОМПАНИЮ
            </h2>
            <div className={`d-flex justify-content-center ${styles.btn}`}>
                <button
                    className={`btn btn-red-filled`}
                    onClick={() => setPopupOpen(true)}
                >
                    Оставить заявку
                </button>
            </div>

            <PopupNRI isOpen={isPopupOpen} onClose={() => setPopupOpen(false)} />
        </section>
    )
}